import { RuleListStatus } from '@wix/rules-panel-ui';
export const getTaskCount = ruleResults => {
  return ruleResults.reduce((counts, ruleResult) => ({
    fail: counts.fail + Number(ruleResult.status === RuleListStatus.failed),
    total: counts.total + 1
  }), {
    fail: 0,
    total: 0
  });
};
//# sourceMappingURL=get-task-count.js.map